import { MATRIX_DATA } from "../components/Matrix/data/matrix-data"
import { DOCS } from '../dict/DOCS'

export const getOrgInfo = (id: string) => {
    if (ORGS.hasOwnProperty(id)){
        let {name, fullname,desc} = ORGS[id]
        return {
            orgName: name,
            orgFullname: fullname,
            orgDesc: desc 
        }
    }
    return {orgName: id, orgFullname: id}
}


export const getOrgsForDoc = (docID: string): string[] => {

   if (DOCS.hasOwnProperty(docID)){
      let {subject_id: orgsID} = DOCS[docID]

      return orgsID.split(';').map(item => item.trim())
   }
   return []

}



export const getOrgsForStage = (stageID: string) => {
    let matrixStages = MATRIX_DATA[0]
    let matrixData = MATRIX_DATA.slice(1)

    let orgsList: string[] = []

    matrixStages.map((stage_id, i) => {
        if (stageID === stage_id){
            matrixData.map(arr => {
                let orgID = arr[0];
                if (arr[i] === 1){
                    orgsList.push('' + orgID)
                }
                return null
            })
            return null
        }
    })

    return orgsList
}





export interface IOrgs {
    [id: string]: {
        name: string,
        fullname: string,
        parent_org_id: string,
        parent_org: string,
        stages_yes: number,
        org_displayed: string,
        connection: string,
        desc: string
    }
}

export const ORGS: IOrgs = {
   "org_1": {
      "name": "КМУ",
      "fullname": "Кабінет Міністрів України",
      "parent_org_id": "",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Вищий орган у системі органів виконавчої влади України. Здійснює виконавчу владу безпосередньо та через міністерства, інші центральні органи виконавчої влади"
   },
   "org_2": {
      "name": "Мін’юст",
      "fullname": "Міністерство юстиції України",
      "parent_org_id": "org_1",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Головний орган у системі центральних органів виконавчої влади, що забезпечує формування та реалізує державну правову політику, у сфері державної реєстрації актів цивільного стану та інших сферах"
   },
   "org_3": {
      "name": "МОЗ",
      "fullname": "Міністерство охорони здоров'я України",
      "parent_org_id": "org_1",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Головний орган у системі центральних органів виконавчої влади, що забезпечує формування та реалізує державну політику у сфері охорони здоров'я, забезпечує формування та реалізує державну політику у системі охорони здоров'я, забезпечення державних фінансових гарантій медичного обслуговування населення"
   },
   "org_4": {
      "name": "МЗС",
      "fullname": "Міністерство закордонних справ України",
      "parent_org_id": "org_1",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Центральний орган виконавчої влади, що забезпечує формування та реалізує державну політику у сфері зовнішніх зносин, діяльність якого спрямовується і координується Кабінетом Міністрів України"
   },
   "org_5": {
      "name": "МОУ",
      "fullname": "Міністерство оборони України",
      "parent_org_id": "org_1",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Головний орган у системі центральних органів виконавчої влади, який забезпечує формування та реалізує державну політику з питань національної безпеки у воєнній сфері, сферах оборони і військового будівництва у мирний час та особливий період"
   },
   "org_6": {
      "name": "Поліція",
      "fullname": "Національна поліція України",
      "parent_org_id": "org_1",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Центральний орган виконавчої влади, який служить суспільству шляхом забезпечення охорони прав і свобод людини, протидії злочинності, підтримання публічної безпеки і порядку"
   },
   "org_7": {
      "name": "ЗОЗ",
      "fullname": "Заклад охорони здоров'я",
      "parent_org_id": "org_3",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Юридична особа незалежно від форми власності та організаційно-правової форми або її відокремлений підрозділ, основними завданнями яких є забезпечення медичного обслуговування населення та/або надання реабілітаційної допомоги на основі відповідної ліцензії та забезпечення професійної діяльності медичних (фармацевтичних) працівників і фахівців з реабілітації"
   },
   "org_37": {
      "name": "Лікарня",
      "fullname": "Лікарня (стаціонар)",
      "parent_org_id": "org_7",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Заклад охорони здоров'я, у якому хворі знаходяться цілодобово до моменту виписки"
   },
   "org_38": {
      "name": "ЦПМСД",
      "fullname": "Центр первинної медико-санітарної допомоги",
      "parent_org_id": "org_7",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Заклад охорони здоров’я, що забезпечує потреби населення у первинній медичній допомозі"
   },
   "org_39": {
      "name": "ФАП",
      "fullname": "Фельдшерсько-акушерський пункт",
      "parent_org_id": "org_7",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Відокремлений структурний підрозділ амбулаторії ЦПМСД, що забезпечує надання долікарської медичної допомоги населенню"
   },
   "org_40": {
      "name": "Швидка",
      "fullname": "Екстрена медична допомога",
      "parent_org_id": "org_7",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "сукупність закладів охорони здоров’я та їх структурних одиниць, які забезпечують здійснення невідкладних організаційних, діагностичних та лікувальних заходів, спрямованих на врятування і збереження життя людини у невідкладному стані та мінімізацію наслідків впливу такого стану на її здоров’я"
   },
   "org_8": {
      "name": "Суд-мед. експертиза",
      "fullname": "Бюро судово-медичної експертизи",
      "parent_org_id": "org_7",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Державна спеціалізована установа, що входить до структури закладів охорони здоров'я України, основною діяльністю бюро є проведення судово-медичних експертиз з метою дослідження на підставі спеціальних знань матеріальних об'єктів, що містять інформацію про обставини справи"
   },
   "org_9": {
      "name": "Відділ РАЦС",
      "fullname": "Відділ реєстрації актів цивільного стану",
      "parent_org_id": "org_19",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Структурний підрозділ в системі орагнів Міністерства юстиції України, що реалізує повноваження Міністерства юстиції України у сфері державної реєстрації актів цивільного стану (народжень, шлюбів, розлучень та смертей)та є юридичною особою"
   },
   "org_10": {
      "name": "Суд",
      "fullname": "Суд (загальні місцеві суди)",
      "parent_org_id": "",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Орган, що здійснює правосуддя у формі розгляду і вирішення цивільних, кримінальних, господарських, адміністративних і інших категорій справ у встановленому законом процесуальному порядку"
   },
   "org_11": {
      "name": "ДРАЦС",
      "fullname": "Державний реєстр актів цивільного стану",
      "parent_org_id": "org_2",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Державна електронна інформаційна система, яка містить відомості про акти цивільного стану, зміни, що вносяться до актових записів цивільного стану, їх поновлення та анулювання та відомості про видачу свідоцтв про державну реєстрацію актів цивільного стану і про видачу витягів з нього. Ведеться відділами державної реєстрації актів цивільного стану."
   },
   "org_12": {
      "name": "Податкова",
      "fullname": "Державна податкова служба України",
      "parent_org_id": "org_1",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Центральний орган виконавчої влади, який реалізує державну податкову політику, державну політику з адміністрування ЄСВ. Діяльність ДПС спрямовується і координується Кабінетом Міністрів України через Міністра фінансів"
   },
   "org_13": {
      "name": "НСЗУ",
      "fullname": "Національна служба здоров'я України",
      "parent_org_id": "org_1",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Центральний орган виконавчої влади, який реалізує державну політику у сфері державних фінансових гарантій медичного обслуговування населення. Діяльність НСЗУ спрямовується і координується Кабінетом Міністрів України через Міністра охорони здоров’я"
   },
   "org_14": {
      "name": "Міграційна",
      "fullname": "Державна міграційна служба",
      "parent_org_id": "org_32",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Центральний орган виконавчої влади, який реалізує державну політику у сферах міграції (імміграції та еміграції), у тому числі протидії нелегальній (незаконній) міграції, громадянства, реєстрації фізичних осіб, біженців та інших визначених законодавством категорій мігрантів. Діяльність ДМС спрямовується та координується Кабінетом Міністрів України через Міністра внутрішніх справ"
   },
   "org_15": {
      "name": "Реєстр виборців",
      "fullname": "Державний реєстр виборців",
      "parent_org_id": "org_41",
      "parent_org": "Центральна виборча комісія",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Автоматизована інформаційно-комунікаційна система, призначена для зберігання, обробки даних, які містять передбачені цим Законом відомості, та користування ними, створена для забезпечення державного обліку громадян України, які мають право голосу."
   },
   "org_16": {
      "name": "Соцзахист",
      "fullname": "Органи праці та соціального захисту населення",
      "parent_org_id": "org_42",
      "parent_org": "мінсоцполітики",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Стурктурні підрозділи системи органів соціального захисту населення — органи,  підпорядковані  відповідним орагнам місцевого самоврядування та підзвітні органам виконавчої влади, що забезпечуть формування та реалізацію державної політики у сфері соціальної політики, загальнообов’язкового державного соціального та пенсійного страхування, соціального захисту населення"
   },
   "org_17": {
      "name": "Військомат",
      "fullname": "Територіальний центр комплектування та соціальної підтримки",
      "parent_org_id": "org_5",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Комплектування військ особовим складом та організація оборонно-мобілізаційної роботи, забезпечення та впровадження ефективної системи обслуговування та надання сервісних послуг з соціального захисту як військовослужбовців так і членів їх родин, резервістів, ветеранів війни та пенсіонерів Збройних Сил та інших військових формувань України"
   },
   "org_18": {
      "name": "Пенсійний",
      "fullname": "Пенсійний фонд України",
      "parent_org_id": "org_1",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Центральний орган виконавчої влади, діяльність якого спрямовується і координується Кабінетом Міністрів України через Міністра соціальної політики, що реалізує державну політику з питань пенсійного забезпечення та ведення обліку осіб, які підлягають загальнообов’язковому державному  соціальному страхуванню."
   },
   "org_19": {
      "name": "Юстиція",
      "fullname": "Міжрегіональне управління юстиції",
      "parent_org_id": "org_2",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Територіальний орган міністерства юстиції України, що реалізує державну правову політику у сфері державної реєстрації актів цивільного стану"
   },
   "org_36": {
      "name": "Управління статистики",
      "fullname": "Головні управління статистики в регіонах",
      "parent_org_id": "org_20",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Територіальний орган державної статистики, підпорядкований Держстату України, що здійснює реалізацію державної політики у сфері статистики"
   },
   "org_20": {
      "name": "Держстат",
      "fullname": "Державна служба статистики України",
      "parent_org_id": "org_1",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Спеціально уповноважений центральний орган виконавчої влади в галузі статистики, діяльність якого спрямовується та координується Кабінетом Міністрів України та який забезпечує формування і реалізує державну політику у сфері статистики"
   },
   "org_21": {
      "name": "ІАЦ медичної статистики",
      "fullname": "Регіональний центр медичної статистики",
      "parent_org_id": "org_22",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Реалізує державну політику з питань медичної статистики, здійснює інформаційно-методичне забезпечення лікувально-профілактичних закладів, економічний аналіз та обґрунтування бюджетних витрат закладів, впровадження інноваційних та сучасних інформаційних технологій у систему охорони здоров’я населення"
   },
   "org_22": {
      "name": "Медстат",
      "fullname": "Центр медичної статистики МОЗ",
      "parent_org_id": "org_3",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Державний заклад «Центр медичної статистики Мiнiстерства охорони здоров'я» є головною установою, що здiйснює координацiю дiяльностi територіальних інформаційно-аналітичних центрiв медичної статистики та лiкувально-профiлактичних закладiв щодо збору, обробки та аналiзу статистичної iнформацiї. Є юридичною особою."
   },
   "org_23": {
      "name": "Близькі та родичі",
      "fullname": "Близькі та родичі померлої особи, інші особи",
      "parent_org_id": "",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Друга особа з подружжя, діти (усиновлені) їх законні представники, близькі родичі померлого (брати і сестри, онукам, діду і бабі як з боку батька, так із боку матері), особа, яка є спадкоємцем за законом або заповітом. У деяких випадках (відсутність близьких чи родичів), заявниками у реєстрації смерті особи можуть бути: сусіди, працівники житлово-експлуатаційних організацій, особа, яка супроводжує тіло померлої особи, прокурор."
   },
   "org_25": {
      "name": "Прокуратура",
      "fullname": "Органи прокуратури",
      "parent_org_id": "org_35",
      "parent_org": "Генеральна прокуратура",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Система органів, що, здійснює підтримання державного обвинувачення в суді, представництво інтересів громадянина або держави в суді у випадках, передбачених законом, нагляд за додержанням законів органами, що провадять оперативно-розшукову діяльність та при виконанні судових рішень у кримінальних справах, а також при застосуванні інших заходів примусового характеру, пов’язаних з обмеженням особистої свободи громадян"
   },
   "org_26": {
      "name": "ЄРДР",
      "fullname": "Єдиний реєстр досудових розслідувань",
      "parent_org_id": "org_32",
      "parent_org": "МВС",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Електронна база даних, до якої здійснюються збирання, зберігання, захист, облік, пошук, узагальнення даних про кримінальні порушення, та хід їх розслідування і які використовуються для формування звітності, а також надання інформації про відомості, внесені до Реєстру"
   },
   "org_27": {
      "name": "Консульства",
      "fullname": "Консульські установи та дипломатичні представництва України",
      "parent_org_id": "org_4",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Дипломатичне представництво України в іншій державі"
   },
   "org_28": {
      "name": "Патанатомія",
      "fullname": "Патанатомічні відділення і бюро",
      "parent_org_id": "org_7",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Окремі заклади охорони здоров'я (бюро) або відділення ЗОЗ (патанатомічні відділення), що здійснюють аналіз причин смерті за результатами патологоанатомічних досліджень, встановлюють науково обґрунтовані причини та механізми смерті"
   },
   "org_29": {
      "name": "Кабінети медстатистики ЗОЗ",
      "fullname": "Кабінети медичної статистики ЗОЗ",
      "parent_org_id": "org_7",
      "parent_org": "ЗОЗ",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Структурний підрозділ закладу охорони здоров'я, що здійснює збір медико-статистичної та адміністративної інформації від підрозділів ЗОЗ, обробляє та аналізує інформацію щодо стану здоров'я населення, обсягів та якості надання медичної допомоги, ресурсів охорони здоров'я та їх використання"
   },
   "org_30": {
      "name": "Патологоанатомічне відділення",
      "fullname": "Патологоанатомічне відділення ЗОЗ",
      "parent_org_id": "org_28",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Структурний підрозділ закладу охорони здоров'я, що здійснює серед іншого облік результатів посмертній) діагностики захворювань та патологічних процесів за матеріалами патологоанатомічних розтинів з урахуванням причин та механізмів смерті, аналіз структури захворюваності та причин смерті населення за результатами аналізу патологоанатомічних досліджень та розгляд випадків розходження клінічних та патологоанатомічних даних і діагнозів на патологоанатомічних конференціях. Не може бути реорганізовано або ліквідовано з метою створення патологоанатомічного бюро"
   },
   "org_31": {
      "name": "Патанатомічне бюро",
      "fullname": "Патолого-анатомічне бюро",
      "parent_org_id": "org_28",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Бюро є закладом охорони здоров'я, що підпорядковується регіональному органу управління охорони здоров'я, головною науково-практичною установою у регіоні з питань прижиттєвої діагностики та лікування захворювань, встановлення науково обґрунтованих причин та механізмів смерті. У разі відсутності у регіоні патологоанатомічних бюро його функції бере на себе патологоанатомічне відділення регіональної лікарні"
   },
   "org_32": {
      "name": "МВС",
      "fullname": "Міністерство внутрішніх справ України",
      "parent_org_id": "org_1",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Головний орган у системі центральних органів виконавчої влади, що забезпечує формування державної політики у сферах забезпечення охорони прав і свобод людини, інтересів суспільства і держави, протидії злочинності, підтримання публічної безпеки і порядку, а також надання поліцейських послуг"
   },
   "org_33": {
      "name": "ОМС",
      "fullname": "Виконавчий комітет органу місцевого самоврядування",
      "parent_org_id": "",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Виконавчий орган сільської, селищної, міської, районної у місті (у разі її створення) ради"
   },
   "org_34": {
      "name": "ЦНАП",
      "fullname": "Центр надання надання адміністративних послуг",
      "parent_org_id": "org_33",
      "parent_org": "",
      "stages_yes": 1,
      "org_displayed": "",
      "connection": "",
      "desc": "Місце надання адміністративних послуг, що надаються органами місцевого самоврядування"
   },
   "org_35": {
      "name": "ГПУ",
      "fullname": "Генеральна прокуратура України",
      "parent_org_id": "",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Орган державної влади, що підтримує публічне обвинувачення в суді, організовує і здійснює процесуальне керівництво досудовим розслідуванням, вирішує інші питання під час кримінального провадження"
   },
   "org_41": {
      "name": "ЦВК",
      "fullname": "Центральна виборча комісія України",
      "parent_org_id": "",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Колегіальний державний орган, який наділений повноваженнями щодо організації підготовки і проведення виборів Президента України, народних депутатів України, депутатів Верховної Ради Автономної Республіки Крим, депутатів місцевих рад та сільських, селищних, міських голів, всеукраїнського і місцевих референдумів"
   },
   "org_42": {
      "name": "Мінсоц",
      "fullname": "Міністерство соціальної політики",
      "parent_org_id": "org_1",
      "parent_org": "",
      "stages_yes": null,
      "org_displayed": "",
      "connection": "",
      "desc": "Центральний орган виконавчої влади, який забезпечує формування та реалізацію державної політики у сфері соціальної політики, загальнообов’язкового державного соціального та пенсійного страхування, соціального захисту населення, волонтерської діяльності, з питань сім’ї та дітей, а також забезпечує формування та реалізує державну політику щодо нагляду за дотриманням норм Закону України “Про загальнообов’язкове державне пенсійне страхування” щодо призначення (перерахування) і виплати пенсій у солідарній системі та щодо взаємодії Пенсійного фонду України з Фондом соціального страхування"
   }
}